import { Cascader } from 'antd'

import EntityBadge from '../Badges/EntityBadge'
import { getOptionPathText, searchOptionPath, sortOptionPaths } from './utils/options'

const LEAF_STYLE = { gap: 5, maxWidth: 'calc(100% - 30px)' }

/** Searching for an option that cannot be picked is pointless, so disabled paths are filtered out. */
const SHOW_SEARCH = {
  filter: (inputValue, path) => !path.some(option => option.disabled) && searchOptionPath(inputValue, path),
  render: (inputValue, path) => getOptionPathText(path),
  sort: sortOptionPaths
}

/**
 * The cascader shared by the institutions and the schools selectors : entities grouped under their
 * commercial category, the selected one displayed with its badge.
 *
 * Expects the options of buildCategoryTree, and hands the raw antd change over : the value shape is
 * the caller's business.
 */
const CategorizedCascader = ({ options, value, disabled, style = {}, placeholder = '', applyCustomStyles = false, onChange }) => {
  const displayRender = (labels, selectedOptions = []) => {
    const leaf = selectedOptions[selectedOptions.length - 1]

    if (!leaf) {
      return labels[labels.length - 1]
    }

    return (
      <span className='flex-row ai-ctr' style={LEAF_STYLE}>
        {leaf.name ?? labels[labels.length - 1]}
        <EntityBadge entity={leaf.data} size='sm' />
      </span>
    )
  }

  return (
    <Cascader
      className={'cascader' + (applyCustomStyles ? ' custom-styles' : '')}
      popupClassName='custom-cascader-width'
      options={options}
      value={value}
      disabled={disabled}
      style={style}
      placeholder={placeholder}
      onChange={onChange}
      displayRender={displayRender}
      showSearch={SHOW_SEARCH}
      expandTrigger='hover'
      size='small'
    />
  )
}

export default CategorizedCascader
